// * 인하대 사업소개 라우트

const inhaInfoRoutes = [
  {
    path: "inha-overview",
    children: [
      {
        path: "",
        name: "InhaOverview",
        meta: {
          title: "사업 안내",
          mobileTitle: "사업 안내",
        },
        component: () => import("@/views/common/main/inha-overview/InhaOverviewIndex.vue"),
      },
      {
        path: "vision",
        name: "InhaVision",
        meta: {
          title: "비전 및 목표",
          mobileTitle: "비전 및 목표",
        },
        component: () => import("@/views/common/main/inha-overview/InhaOverviewVision.vue"),
      },
      {
        path: "organization",
        name: "InhaOrganization",
        meta: {
          title: "조직도",
          mobileTitle: "조직도",
        },
        component: () => import("@/views/common/main/inha-overview/InhaOverviewOrganization.vue"),
      },
      {
        path: "directions",
        name: "InhaDirections",
        meta: {
          title: "찾아오시는 길",
          mobileTitle: "찾아오시는 길",
        },
        component: () => import("@/views/common/main/inha-overview/InhaOverviewDirections.vue"),
      },
    ],
  },
];

export default inhaInfoRoutes;
